import Flickity from 'flickity';

let carousels = document.querySelectorAll('[data-module="hero-carousel"]');

for(let i = 0, length1 = carousels.length; i < length1; i++){

    let defaultOptions = {
        dots: false,
        arrows: false,
        autoplay: false
    };

    var defaultArrowShape = "M 72.37 97.59 C 70.96 97.59 69.55 97.03 68.42 95.9 L 26.69 53.6 C 24.43 51.34 24.43 47.96 26.69 45.7 L 68.42 3.69 C 70.68 1.43 74.06 1.43 76.32 3.69 C 78.58 5.95 78.58 9.33 76.32 11.59 L 38.53 49.65 L 76.32 88 C 78.58 90.26 78.58 93.92 76.32 95.9 C 75.47 97.03 73.78 97.59 72.37 97.59 Z";


    if( typeof carousels[i].dataset.moduleOptions !== 'undefined' ){
        const options = JSON.parse( carousels[i].dataset.moduleOptions );

        defaultOptions.dots     = options.dots;
        defaultOptions.arrows   = options.arrows;
        defaultOptions.autoplay = (options.autoplay===false) ? options.autoplay : (options.autoplay*1000);
    }

    var flkty = new Flickity( carousels[i], {
        cellAlign: 'center',
        contain: true,
        wrapAround: true,
        lazyLoad: true,
        prevNextButtons: defaultOptions.arrows,
        autoPlay: defaultOptions.autoplay,
        pageDots: defaultOptions.dots,
        arrowShape: defaultArrowShape,
        on:{
            ready: function(){
                var t = this;
                if(defaultOptions.dots){
                    repositionDots( t );

                    window.onresize = function(){
                        repositionDots( t );
                    }
                }
            },
            change: function(){
                var t = this;
                if(defaultOptions.dots){
                    repositionDots( t );
                }
            },
            settle: function(){
                var t = this;
                if(defaultOptions.dots){
                    repositionDots( t );
                }
            },
            lazyLoad: function(){
                var t = this;
                if(defaultOptions.dots){
                    repositionDots( t );
                }
            }
        }
    });

    function repositionDots( instance ){
        if(instance){
            let carousel = instance.element;
            let dots = instance.pageDots.holder;
            let current_slide = instance.selectedElement.childNodes;
            let current_slide_img = null;
            let current_slide_content = null;

            for(let i = 0, length1 = current_slide.length; i < length1; i++){
                if( current_slide[i].attributes){

                    if( current_slide[i].attributes.getNamedItem('class').value.includes("image") ){
                        current_slide_img = current_slide[i];
                    }

                    if( current_slide[i].attributes.getNamedItem('class').value.includes("content") ){
                        current_slide_content = current_slide[i];
                    }
                }
            }

            if(window.innerWidth <= 899){
                current_slide_content.style = null;
                dots.style.top = (current_slide_img.offsetHeight + 20) + 'px';
                dots.style.left = null;
            }
            else{
                current_slide_content.style.bottom = null;
                current_slide_content.style.width = null;

                if(current_slide_content.offsetTop < 20){
                    current_slide_content.style.bottom = "50px";
                    current_slide_content.style.width = "50%";
                }

                dots.style.top = (current_slide_content.offsetTop + (current_slide_content.offsetHeight/2) - 30) + 'px';
                dots.style.left = (current_slide_content.offsetLeft + 30) + 'px';
            }
        }
    }
}

